import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PrivacyPreferencesFields } from "@/components/privacy/PrivacyPreferencesFields";

export function PrivacyPreferencesDialog({
  open,
  onOpenChange,
  analyticsEnabled,
  onAnalyticsChange,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="border-zinc-800 bg-[#09090b] text-zinc-100 sm:max-w-md"
        data-testid="privacy-preferences-dialog"
      >
        <DialogHeader>
          <DialogTitle>Preferências de privacidade</DialogTitle>
          <DialogDescription className="text-zinc-400">
            Você pode alterar o uso de analytics a qualquer momento. Essenciais
            permanecem sempre ativos.
          </DialogDescription>
        </DialogHeader>

        <div className="py-2">
          <PrivacyPreferencesFields
            analyticsEnabled={analyticsEnabled}
            onAnalyticsChange={onAnalyticsChange}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
